import { IGF } from "../../content/eventsArchive";
import { Page } from "../../layout/Page";
import { Button } from "../../ui/Button";
import { Reveal } from "../../ui/Reveal";
import { Section } from "../../ui/Section";

export function IgfPage() {
  return (
    <Page title="International Gita Forum" heading={IGF.title}>
      <Section eyebrow={IGF.date} lede={IGF.lead}>
        <div className="grid gap-6 sm:grid-cols-2">
          {IGF.posters.map((p) => (
            <Reveal key={p.src}>
              <img
                src={p.src}
                alt={p.alt}
                className="w-full rounded-lg object-cover"
                loading="lazy"
              />
            </Reveal>
          ))}
        </div>
        <div className="mt-8">
          <Button href={IGF.video} external size="lg">
            Watch the recording
          </Button>
        </div>
      </Section>
    </Page>
  );
}
